import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=0be44cb6&scoped=true&"
import script from "./statistics.vue?vue&type=script&lang=ts&"
export * from "./statistics.vue?vue&type=script&lang=ts&"
import style0 from "./statistics.vue?vue&type=style&index=0&id=0be44cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be44cb6",
  null
  
)

export default component.exports